<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onSymbolGroupSelected(null)">
          <i class="fa-solid fa-plus"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>

    </breadcrumb-button>
    <!--Filters-->
    <filter-card f v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t('menu.symbolGroups') }}</h5>
      </b-card-header>
      <b-card-body>
        <symbolGroup-table ref="symbolGroupTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false"
                        @selected="onSymbolGroupSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="symbolGroup" v-model="columns"
                   v-bind:columns-names="columnsNames"
    />
    <symbolGroup-modal ref="symbolGroup-modal"/>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import BreadcrumbButton from '@/components/widget/breadcrumbButton';
import SymbolGroupSearchRequest from '@/model/symbolGroup/SymbolGroupSearchRequest';
import ColumnsModal from '@/components/modal/columnsModal';
import SymbolGroup from '@/model/symbolGroup/SymbolGroup';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinBase from '@/components/mixin/mixinBase';
import SymbolGroupModal from '@/components/modal/symbolGroupModal';
import FilterCard from '@/components/widget/FilterCard';
import SymbolGroupFilterFields from '@/model/filter/SymbolGroupFilterFields';
import SymbolGroupTable from '@/components/tables/SymbolGroupTable';

export default {
  name: 'SymbolGroupView',
  components: {
    SymbolGroupTable,
    FilterCard,
    SymbolGroupModal,
    ColumnsModal,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(SymbolGroup()),
      filter: SymbolGroupSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    };
  },
  watch: { },
  async created() {
    await this.refreshData();
    this.filterFields = SymbolGroupFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('symbolGroup', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal();
    },
    onSymbolGroupSelected(selectedId) {
      // console.log("onSymbolGroupSelected", selectedId)
      this.$refs['symbolGroup-modal'].showModal(selectedId);
    },
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
